import React, {Component, Fragment} from 'react';
import {BrowserRouter as Router, Route, Redirect} from 'react-router-dom';
import axios from 'axios';
import {inject} from 'mobx-react'

import Loader from './elements/Loader';

import Navigation from './Navigation';
import List from './pages/List';
import CovidList from './pages/CovidList';
import Register from './pages/Register';
import Registerch from './pages/Registerch';
import RegisterCovid from './pages/RegisterCovid';

class Layout extends Component {
  constructor(props) {
    super(props)
    this.state = {
      user: {},
      loading: true
    }
  }

  componentDidMount(){
    this.loadUser();
    this.dymoInit();
  }

  loadUser = () => {
    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_URL}/profile`,
    }).then(res => {
      console.log(res)
      this.setState({
        user: res.data.item,
        loading: false,
      })
    }).catch(err => {
      console.log(err)
      this.setState({
        user: {},
        loading: false,
      })
    });
  }

  dymoInit = () => {
    console.log(window.dymo)
    var self = this
    window.dymo.label.framework.init(function(){
      window.dymo.label.framework.checkEnvironment()
      self.props.Printers.setPrinters(window.dymo.label.framework.getLabelWriterPrinters())
    });
  }

  render() {
    return (
      <div className="container-fluid">
        <Router>
          {this.state.loading
            ? (
              <div className="page-center" style={{textAlign: 'center'}}><Loader/></div>
            ) : (
              <Fragment>  
                {window.location.pathname.split('/')[1] !== 'register' && window.location.pathname.split('/')[1] !== 'register-covid' && window.location.pathname.split('/')[1] !== 'register-ch'  ? <Navigation user={this.state.user}/>: null}              
                <div className="page-wrapper">  
                  <Route exact path="/" render={({match})=> <Redirect to="/list"/>} />
                  <Route exact path="/register/:id" component={Register}/> 
                  <Route exact path="/register-ch/:id" component={Registerch}/>
                  <Route exact path="/register-covid/:id" component={RegisterCovid}/>
                  <Route path="/list" render={({match, location, history}) => {
                    if (this.state.user.covidSite){
                      return (<CovidList {...match} user={this.state.user}/>)
                    } else {
                      return (<List {...match} user={this.state.user}/>)
                    }
                    
                  }}/>                
                </div>                 
              </Fragment>              
            )}
        </Router>
      </div>
    )
  }
}
export default inject('Printers')(Layout)
